import React from 'react';

export const Marquee = ({ text }) => {
  return (
    <div className="bg-[#ff8001c5] py-2 overflow-hidden whitespace-nowrap relative">
      <div className="inline-flex animate-marquee hover:pause-marquee">
        {/* First copy */}
        <span className="text-black font-semibold text-sm md:text-base px-4">
          {text}
        </span>
        {/* Second copy for seamless loop */}
        <span className="text-black font-semibold text-sm md:text-base px-4">
          {text}
        </span>
        {/* Third copy to ensure no gaps */}
        <span className="text-black font-semibold text-sm md:text-base px-4">
          {text}
        </span>
      </div>

      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-marquee {
          animation: marquee 30s linear infinite;
          will-change: transform;
        }

        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};